import { supabase } from '@/integrations/supabase/client'

export const sendContactEmail = async (formData: {
  naam: string
  email: string
  telefoon: string
  onderwerp: string
  bericht: string
}) => {
  try {
    // Create contact submission in database
    const { data, error } = await supabase
      .from('contact_submissions')
      .insert([
        {
          naam: formData.naam,
          email: formData.email,
          telefoon: formData.telefoon,
          onderwerp: formData.onderwerp,
          bericht: formData.bericht,
          created_at: new Date().toISOString()
        }
      ])

    if (error) throw error

    // Send emails via Supabase Edge Function
    const { data: emailData, error: emailError } = await supabase.functions.invoke('send-contact-email', {
      body: {
        naam: formData.naam,
        email: formData.email,
        telefoon: formData.telefoon,
        onderwerp: formData.onderwerp,
        bericht: formData.bericht
      }
    })

    if (emailError) throw emailError

    return { success: true, data, emailData }
  } catch (error) {
    console.error('Error sending contact email:', error)
    return { success: false, error }
  }
}